import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "overlay", "startTime", "endTime", "form"]

  open(event) {
    event.preventDefault()
    const { startTime, endTime, url } = event.currentTarget.dataset

    this.startTimeTarget.value = startTime
    this.endTimeTarget.value = endTime
    this.formTarget.action = url

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
